// Colors 

export const COLORS = {
    secondary: '#10172B',
    primary: '#71AE4D',
}
